import {autoinject} from "aurelia-framework";
import {CartService} from "../cart-service";
import {Router} from "aurelia-router";

@autoinject()
export class PageSuccess {

    constructor(private cartService: CartService, private router: Router) {

    }

    attached() {
        this.cartService.paymentSucceeded()
    }

    next() {
        this.router.navigate("page1-intro")
    }

}